(function () {
  function isMobileOrTablet() {
    return window.matchMedia("(max-width: 1024px)").matches || ("ontouchstart" in window);
  }

  function ensureModal() {
    if (document.getElementById("pdfModal")) return;

    var modal = document.createElement("div");
    modal.id = "pdfModal";
    modal.className = "hh-pdf-modal";
    modal.setAttribute("aria-hidden", "true");

    modal.innerHTML = `
      <div class="hh-pdf-backdrop" data-hh-close="true"></div>
      <div class="hh-pdf-dialog" role="dialog" aria-modal="true" aria-label="PDF Viewer">
        <div class="hh-pdf-header">
          <div class="hh-pdf-title">Supporting Study (PDF)</div>
          <button class="hh-pdf-close" type="button" aria-label="Close" data-hh-close="true">✕</button>
        </div>
        <iframe id="hhPdfFrame" class="hh-pdf-frame" src="" title="Supporting Study PDF"></iframe>
        <div class="hh-pdf-footer">
          <a id="hhPdfOpenNew" href="#" target="_blank" rel="noopener">Open in new tab</a>
        </div>
      </div>
    `;

    document.body.appendChild(modal);
  }

  function openModal(url) {
    ensureModal();
    var modal = document.getElementById("pdfModal");
    var frame = document.getElementById("hhPdfFrame");
    var openNew = document.getElementById("hhPdfOpenNew");

    frame.src = url;
    openNew.href = url;

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("hh-pdf-lock");
    document.body.classList.add("hh-pdf-lock");
  }

  function closeModal() {
    var modal = document.getElementById("pdfModal");
    var frame = document.getElementById("hhPdfFrame");
    if (!modal || !frame) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    frame.src = "";

    document.documentElement.classList.remove("hh-pdf-lock");
    document.body.classList.remove("hh-pdf-lock");
  }

document.addEventListener("click", function (e) {
  var modal = document.getElementById("pdfModal");

  // If click is inside modal, don't intercept (lets "Open in new tab" work)
  if (modal && modal.contains(e.target)) {
    var closeInside = e.target.closest('[data-hh-close="true"]');
    if (closeInside && modal.classList.contains("is-open")) {
      e.preventDefault();
      closeModal();
    }
    return;
  }

  // Close actions
  var closeEl = e.target.closest('[data-hh-close="true"]');
  if (closeEl && modal && modal.classList.contains("is-open")) {
    e.preventDefault();
    closeModal();
    return;
  }

  // Grab nearest link
  var a = e.target.closest("a[href]");
  if (!a) return;

  // Never intercept the modal footer link
  if (a.id === "hhPdfOpenNew") return;

  var href = (a.getAttribute("href") || "").trim();
  if (!href) return;

  // Only intercept PDFs (safe) — strongly recommend limiting to Shopify CDN PDFs
  var isPdf = href.toLowerCase().includes(".pdf");
  if (!isPdf) return;

  // OPTIONAL safety: only intercept Shopify-hosted PDFs
  if (!href.includes("cdn.shopify.com")) return;

  // Mobile/tablet: open new tab
  if (isMobileOrTablet()) {
    e.preventDefault();
    window.open(href, "_blank", "noopener");
    return;
  }

  // Desktop: open modal
  e.preventDefault();
  openModal(href);
});

  document.addEventListener("keydown", function (e) {
    var modal = document.getElementById("pdfModal");
    if (e.key === "Escape" && modal && modal.classList.contains("is-open")) {
      closeModal();
    }
  });
})();